import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPicker, Input } from "uxp/components";
import { findAvailableFields, IPropertyEditorProps, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle, TextAlignEditor } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionEditorLink, { IAction } from "../../../common/action-editor/ActionEditor";
import { bindContainerId } from "../../../../util";
import { Conditional } from "../../../common/ConditionalComponent";

export interface ICardListProps {
    viewHeight: number,
    makeInactiveSlidesSmall: boolean,
    slidesPerView: number,
    centeredSlides: boolean,
    showImageSeperately: boolean,
    onClickRow?: IAction
}

export function CardListProperty(title: string, props: ICardListProps): IUIPropertyDefinition<ICardListProps> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();


            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property>
                        <PropertyTitle>Show Image Seperately</PropertyTitle>

                        <Checkbox
                            checked={props.uiProps?.showImageSeperately || false}
                            onChange={s => {
                                jp.apply(_props, '$.showImageSeperately', () => (s))
                                props.onChange(_props)
                            }}
                            label={"Show Image Seperately"}
                            type="bordered"
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>Use Centered Slides </PropertyTitle>

                        <Checkbox
                            checked={props.uiProps?.centeredSlides || false}
                            onChange={s => {
                                jp.apply(_props, '$.centeredSlides', () => (s))
                                props.onChange(_props)
                            }}
                            label={"Use Centered Slides"}
                            type="bordered"
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>Make Inactive Slides Small</PropertyTitle>

                        <Checkbox
                            checked={props.uiProps?.makeInactiveSlidesSmall || false}
                            onChange={s => {
                                jp.apply(_props, '$.makeInactiveSlidesSmall', () => (s))
                                props.onChange(_props)
                            }}
                            label={"Make Inactive Slides Small"}
                            type="bordered"
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>Slides Per View</PropertyTitle>

                        <Input
                            type="number"
                            value={_props.slidesPerView?.toString() || '1.2'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.slidesPerView', () => (num))
                                props.onChange(_props)
                            }}
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>View Height</PropertyTitle>

                        <Input
                            type="number"
                            value={_props.viewHeight?.toString() || '330'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.viewHeight', () => (num))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    {/* <Property>
                        <PropertyTitle>On click an item </PropertyTitle>
                        <ActionEditorLink

                            uxpContext={uxpContext}
                            action={_props.onClickRow}
                            onChange={s => {
                                jp.apply(_props, '$.onClickRow', () => (s))
                                props.onChange(_props)
                            }}
                            data={data}
                        />
                    </Property> */}
                </PropertyGroup>
            </PropertyContainer>
        }
    };
}
